import React from 'react';

import { LightningIcon } from 'shared/assets/lightning-icon';
import { shouldHideLoyaltyPointsForRec } from 'shared/core/helpers/dispensaries';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { formatMaskedPhoneNumber } from 'src/components/kiosk-pro/kiosk-pro-shared/format-phone-number';
import {
  Badge,
  InfoContainer,
  InfoText,
  LoginButton,
  LoginContainer,
  LoginText,
  Points,
  ThemedEmbeddedAccountIcon,
} from './consumer-info.styles';

type ConsumerSectionProps = {
  createPublicContextSessionLoading: boolean;
  guestPhoneNumber?: string | null;
  hasGuestPhone: boolean;
  hasLoyaltyIntegration: boolean;
  isUserLoggedIn: boolean;
  kioskProModalLogin: () => Promise<void>;
  loyaltyPoints: string;
  userFirstName?: string;
};

/**
 * Renders the consumer info section based on login state.
 */
export function ConsumerSection({
  createPublicContextSessionLoading,
  guestPhoneNumber,
  hasGuestPhone,
  hasLoyaltyIntegration,
  isUserLoggedIn,
  kioskProModalLogin,
  loyaltyPoints,
  userFirstName,
}: ConsumerSectionProps): JSX.Element {
  const { dispensary } = useDispensary();
  const shouldHideLoyaltyPoints = shouldHideLoyaltyPointsForRec(dispensary);

  if (isUserLoggedIn) {
    return (
      <InfoContainer data-testid='kiosk-pro-consumer-info-container'>
        <ThemedEmbeddedAccountIcon />

        <InfoText>
          <span aria-hidden='true'>👋</span>
          &nbsp; Hi, {userFirstName}!
          {hasLoyaltyIntegration && !shouldHideLoyaltyPoints && <Points>{loyaltyPoints.toLocaleString()} pts</Points>}
        </InfoText>
      </InfoContainer>
    );
  }

  if (hasGuestPhone) {
    return (
      <InfoContainer data-testid='kiosk-pro-consumer-info-container'>
        <ThemedEmbeddedAccountIcon />

        <InfoText>{formatMaskedPhoneNumber(guestPhoneNumber ?? '')}</InfoText>
      </InfoContainer>
    );
  }

  return (
    <LoginButton onClick={kioskProModalLogin} loading={createPublicContextSessionLoading}>
      <LoginContainer>
        <Badge>
          <LightningIcon /> Faster checkout
        </Badge>

        <LoginText>
          Login to reorder
          <br />
          your favorites
        </LoginText>
      </LoginContainer>
    </LoginButton>
  );
}
